<form
  [formGroup]="maandJaarForm"
  (ngSubmit)="onDownloadClick()">
  <mat-form-field>
    <mat-label>export</mat-label>
    <mat-select required
      formControlName="exportOption">
      @for (exportOption of exportOptions; track exportOption) {
        <mat-option [value]="exportOption">
          {{exportOption}}
        </mat-option>
      }
    </mat-select>
    @if (exportOption.hasError('required')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>

  <mat-form-field (click)="picker.open()">
    <mat-label>Maand</mat-label>
    <input matInput
      [matDatepicker]="picker"
      formControlName="maandJaar"
      [placeholder]="maandJaarPlaceholder"
      disabled
      required>
    <mat-datepicker-toggle matSuffix
      [for]="picker">
    </mat-datepicker-toggle>
    <mat-datepicker #picker
      startView="year"
      (yearSelected)="onYearSelected($event)"
      (monthSelected)="onMontSelected($event, picker)"
      disabled="false">
    </mat-datepicker>
    @if (maandJaar.hasError('required')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <button mat-raised-button
    color="primary"
    type="submit"
    [disabled]="!maandJaarForm.valid">
    Download
  </button>
</form>
